export default "__VITE_ASSET__a79481f4__"